import { useCallback } from "react";

import moment from "moment-timezone";

import { FRICTION_TYPE_FILTER_KEYS } from "org/controlActivities/list/frictionTypeFilter";
import { useActivitiesUrlDependencies } from "org/dashboard/hooks/useActivitiesUrlDependencies";
import {
    ActivitiesUrlParams,
    buildCanonicalActivitiesUrl,
} from "org/dashboard/utils/activitiesUrl";

import { useControlHealthFilters } from "./filters/ControlHealthFiltersProvider";
import { FrictionBreakdownView } from "./frictionBreakdownData";

export function useBuildFrictionBucketUrl(view: FrictionBreakdownView) {
    const { filters } = useControlHealthFilters();
    const dependencies = useActivitiesUrlDependencies();

    return useCallback(
        (bucket: { start: string; end: string }, seriesKey: string) => {
            const segmentStates: ActivitiesUrlParams["statusKey"] =
                seriesKey === "inProgress"
                    ? ["Pending", "Overdue"]
                    : ["Completed", "CompletedAfterDueDate"];
            return buildCanonicalActivitiesUrl(
                {
                    dateRange: {
                        start: moment(bucket.start).startOf("day"),
                        end: moment(bucket.end).endOf("day"),
                    },
                    statusKey: view === "all" ? null : segmentStates,
                    frictionTypeFilter:
                        view === "all"
                            ? Object.values(FRICTION_TYPE_FILTER_KEYS)
                            : [view],
                    filteredControlProgramIds: filters.controlPrograms,
                    filteredTags: filters.tags,
                    filteredEntityIds: filters.entities,
                    showArchivedActivities: filters.showArchivedActivities,
                    showInactivePrograms: filters.showInactivePrograms,
                },
                dependencies
            );
        },
        [filters, dependencies, view]
    );
}
